import { titleUI } from 'platform/forms-system/src/js/web-component-patterns';
import { addressSchema, addressUI } from '../../../definitions';
import content from '../../../locales/en/content.json';
import { FULL_SCHEMA } from '../../../utils/imports';

const TITLE_TEXT = content['vet-info-title--address'];
const DESC_TEXT = content['vet-address-description'];
const HINT_TEXT = content['vet-address-street-hint'];

const ADDRESS_PROPS = FULL_SCHEMA.definitions.address.properties;

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT, DESC_TEXT),
    veteranAddress: addressUI({
      streetHint: HINT_TEXT,
    }),
  },
  schema: {
    type: 'object',
    required: ['veteranAddress'],
    properties: {
      veteranAddress: addressSchema({ extend: ADDRESS_PROPS }),
    },
  },
};
